import { FaCopy, FaExclamationCircle } from "react-icons/fa";
import FlagIcon from "./FlagIcon";
import FormattedJSON from "./FormattedJSON";

const DialogueBubble = ({
  index,
  isAI,
  isTool,
  isAgentAction = false,
  isAgentActionBlocked = false,
  message,
  jsonData = null,
  time,
  isTimecodedTranscriptMessage = false,
  hasError = false,
}) => {
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  const processText = (text) => {
    const combinedPattern = /<<([^>]+)>>|\[([^\]]+)\]/g;
    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = combinedPattern.exec(text)) !== null) {
      if (match.index > lastIndex) {
        parts.push(text.slice(lastIndex, match.index));
      }

      const flagContent = match[1] || match[2];
      parts.push(<FlagIcon key={match.index} flag={flagContent} />);

      lastIndex = match.index + match[0].length;
    }

    return parts.length > 0 ? parts : [text];
  };

  const processedText = isTimecodedTranscriptMessage
    ? message
    : processText(message);

  return (
    <div
      key={`${index}-${time}`}
      className={`mb-4 ${isTool || isAI || isAgentAction ? "text-left" : "text-right"}`}
    >
      <div
        className={`relative inline-block max-w-3/4 p-3 rounded-lg group transition-colors duration-200 ${
          isTool
            ? "bg-yellow-500 hover:bg-yellow-400 text-gray-800"
            : isAgentAction
              ? isAgentActionBlocked
                ? "bg-orange-600 hover:bg-orange-500 text-white"
                : "bg-green-700 hover:bg-green-600 text-white"
              : isAI
              ? "bg-gray-700 hover:bg-gray-600 text-white"
              : "bg-blue-600 hover:bg-blue-500 text-white"
        }`}
      >
        <button
          onClick={() => copyToClipboard(message)}
          className={`absolute top-1 ${
            isTool || isAI || isAgentAction ? "right-1" : "left-1"
          } opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-xs ${
            isTool
              ? "text-gray-600 hover:text-black"
              : "text-gray-300 hover:text-white"
          }`}
        >
          <FaCopy />
        </button>

        {isAgentAction ? (
          <>
            <div className="text-sm font-semibold mb-2">{message}</div>
            <FormattedJSON json={JSON.stringify(jsonData, null, 2)} variant="bubble" />
          </>
        ) : (
          <div
            className="text-sm flex items-start"
            style={{ whiteSpace: "pre-line" }}
          >
            {hasError && (
              <span
                className="text-red-500 mr-1.5 font-bold select-none"
                style={{ color: "#ef4444" }}
              >
                <FaExclamationCircle />
              </span>
            )}
            <span>{processedText}</span>
          </div>
        )}

        <div className="flex justify-end items-center mt-2">
          <span
            className={`text-xs ${isTool ? "text-gray-600" : isAgentActionBlocked ? "text-orange-200" : isAgentAction ? "text-green-200" : "text-gray-400"}`}
          >
            {time}
          </span>
        </div>
      </div>
    </div>
  );
};

export default DialogueBubble;
